import TopBar from '@/pages/home/components/TopBar';
import Hero from '@/pages/home/components/Hero';
import Synopsis from '@/pages/home/components/Synopsis';
import Themes from '@/pages/home/components/Themes';
import EpisodeList from '@/pages/home/components/EpisodeList';
import Characters from '@/pages/home/components/Characters';
import Scenes from '@/pages/home/components/Scenes';
import Guide from '@/pages/home/components/Guide';
import Collections from '@/pages/home/components/Collections';
import Faq from '@/pages/home/components/Faq';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 flex flex-col">
      <TopBar />
      <main className="flex-1 w-full">
        <Hero />
        <Synopsis />
        <Themes />
        <EpisodeList />
        <Characters />
        <Scenes />
        <Guide />
        <Collections />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}